export const DEVICE = {
    IOS: "IOS",
    ANDROID: "ANDROID",
    OTHER: "OTHER"
}

export const INFO_CREATE_TRANS = {
    BANK_CODE: "VIETQR",
    CURRENCY_CODE: "VND",
    TYPE: "10",
    BANK_TYPE: "10",
    SERVICE_TYPE: "10"
}

export const formatVND = (number) => {
    return Number(number).toLocaleString("vi-VN") + "đ";
};

export const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return '';
  
    const formattedNumber = phoneNumber.startsWith('84')
      ? `0${phoneNumber.slice(2)}`
      : phoneNumber;
  
    return formattedNumber.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3');
};

export const TRANSACTION_STATUS = {
    SUCCESS: 2,
    FAIL: -1,
    TIMEOUT: 56
}

export const ACTION_IR_REGISTER = {
    ACTIVE: "ir_register",
    IN_ACTIVE: "ir_deregister",
}

export const cycleMapping = {
    5: "6 tháng",
    6: "năm",
    7: "3 ngày",
    8: "10 ngày",
    3: "tháng",
    1: "ngày",
    2: "tuần",
    4: null,
    17: "1 tháng",
    15: "3 tháng",
    9: "9 tháng",
    10: "7 tháng",
    11: "14 tháng",
    13: "5 ngày",
    14: "12 tháng",
    16: "13 tháng",
};

export const TRANSACTION_TYPE = {
    SUCCESS: "success",
    FAIL: "fail",
    PROCESS: "process",
}

export const FILTER_PRICE = [
    { label: "Thấp đến cao", value: "asc" },
    { label: "Cao đến thấp", value: "desc" },
]

export const BANNER_PACKAGE_CODE = {
    ROAMING_RESULTTRANS: "ROAMING_RESULTTRANS",
    ROAMING_DIRECTAPP: "ROAMING_DIRECTAPP",
}